export enum BaseShippingCategoryEnum {
  BaseShippingCategoryCollection="BaseShippingCategoryCollection",
  BaseShippingCategory="BaseShippingCategory",
}
export enum BaseShippingCategoryDataStatus {
  active="active",
  inactive="inactive",
}
